<template>
  <content-editor
    permission="news"
    :publication="true"
    :fields="fields"
    @update="updateState"
    :updatePossible="true"
    endpoint="news"
    previewModule="actueel"
    module="news">
  </content-editor>
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  components: {
    ContentEditor,
  },
  data() {
    return {
      module: 'news',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'title',
          required: true,
        },
        {
          name: 'projects',
          required: false,
        },
        {
          name: 'makers',
          required: false,
        },
        {
          name: 'internal',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'recap',
          required: true,
        },
        {
          name: 'categories',
          required: true,
        },
        {
          name: 'tags',
          required: false,
        },
        {
          name: 'image',
          required: true,
        },
      ],
    };
  },

};
</script>
